import { belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import type AlertTriggeredJournalEvent from "parog-web/models/alert-triggered-journal-event";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class AlertOngoingJournalEvent extends JournalEvent {
  static override type = "alert-ongoing-journal-event";

  @belongsTo("alert-triggered-journal-event", {
    async: false,
    inverse: "alertOngoingJournalEvent"
  })
  declare alertTriggeredJournalEvent: AlertTriggeredJournalEvent;

  static override validations(intl: IntlService) {
    return {
      alertTriggeredJournalEvent: validatePresence({
        presence: true,
        description: intl.t(
          "validations.alert-ongoing-journal-event.alert-triggered-journal-event"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.alert-ongoing-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "alert-ongoing-journal-event": AlertOngoingJournalEvent;
  }
}
